var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-input',{staticClass:"w-full",attrs:{"icon":"search","placeholder":"Search Files","size":"large"},on:{"keyup":_vm.searchFile},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }